import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

function Hero() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const handleButtonClick = (link) => {
    navigate(i18n.language === 'bs' ? link : `/${i18n.language}${link}`);
  };

  return (
    <div 
      className="hero-section custom-hero-bg"
      style={{
        width: '100%',
        height: '75vh',
        minHeight: '600px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        color: '#fff',
        textAlign: 'left',
        padding: '0 5%',
        position: 'relative'
      }}
    >
      <div 
        className="hero-content"
        style={{
          maxWidth: '600px',
          padding: '30px',
          borderRadius: '15px',
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          animation: 'fadeInUp 1s ease-out',
          marginLeft: '5%',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <h1 
          style={{ 
            fontSize: 'clamp(1.8rem, 3vw, 2.5rem)', 
            fontWeight: '800', 
            marginBottom: '1rem', 
            textTransform: 'uppercase', 
            letterSpacing: '1px',
            textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
            fontFamily: '"Quicksand", sans-serif',
            color: '#f9be4f'
          }}
        >
          {t('homePage.hero_title', 'PawFriends Sarajevo')}
        </h1>
        <p 
          style={{ 
            fontSize: '1.05rem', 
            marginBottom: '1.8rem', 
            lineHeight: '1.6',
            color: '#f8f9fa',
            textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
            fontFamily: '"Quicksand", sans-serif'
          }}
        >
          {t('homePage.hero_description', 'Providing a safe home, love, and a fresh start for abandoned dogs and cats.')}
        </p>
        <button
          className="btn btn-primary"
          onClick={() => handleButtonClick('/adoption')}
          type="button"
          style={{ 
            padding: '12px 28px', 
            fontSize: '1.1rem', 
            borderRadius: '50px', 
            textTransform: 'uppercase', 
            fontWeight: '700', 
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
            fontFamily: '"Quicksand", sans-serif'
          }}
        >
          {t('homePage.see_all_pets')}
        </button>
      </div>
      
      {/* Scroll indicator */}
      <div 
        onClick={() => {
          window.scrollBy({ top: window.innerHeight - 70, left: 0, behavior: 'smooth' });
        }}
        style={{
          position: 'absolute',
          bottom: '30px',
          left: '50%',
          transform: 'translateX(-50%)',
          animation: 'bounce 2s infinite',
          cursor: 'pointer',
          zIndex: 10
        }}
        title="Scroll down"
      >
        <i className="fa fa-chevron-down" style={{ fontSize: '2.5rem', color: 'rgba(255,255,255,0.9)', textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}></i>
      </div>

      <style>
        {`
          .custom-hero-bg {
            background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7)), url("/img/slide6.jpg");
            background-size: cover;
            background-position: center;
            background-attachment: fixed;
          }
          @media (max-width: 768px) {
            .custom-hero-bg {
              background-attachment: scroll; /* Fixes blurry issue on mobile iOS Safari */
            }
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% {
              transform: translateY(0) translateX(-50%);
            }
            40% {
              transform: translateY(-20px) translateX(-50%);
            }
            60% {
              transform: translateY(-10px) translateX(-50%);
            }
          }
        `}
      </style>
    </div>
  );
}

export default Hero;